// extracted by mini-css-extract-plugin
module.exports = {"animationH":"animationH_animationH__8BUtn"};